import { useState, useCallback } from 'react';
import { BraveBupAPI } from '@BUP/services/Axios';

export const useSendMetricsQuestionPro = () => {
  const [postData, setPostData] = useState({
    loadingResponseMetrics: false,
    dataResponseMetrics: null,
    errorResponseMetrics: null,
  });
  const sendMetricsQP = useCallback(
    async ({ data }) => {
      setPostData((prevState) => ({
        ...prevState,
        loadingResponseMetrics: true,
      }));
      try {
        const response = await BraveBupAPI.post(`/metricsquestionpro`, data);
        setPostData((prevState) => ({
          ...prevState,
          dataResponseMetrics: response.data,
        }));
        return response.data;
      } catch (error) {
        console.log('error', error);
        setPostData((prevState) => ({
          ...prevState,
          errorResponseMetrics: error,
        }));
      } finally {
        setPostData((prevState) => ({
          ...prevState,
          loadingResponseMetrics: false,
        }));
      }
    },
    [setPostData]
  );
  return {
    loadingResponseMetrics: postData.loadingResponseMetrics,
    dataResponseMetrics: postData.dataResponseMetrics,
    errorResponseMetrics: postData.errorResponseMetrics,
    sendMetricsQP,
  };
};
